import React from 'react'
import styled, { css } from 'styled-components'
import format from 'date-fns/format'
import differenceInMinutes from 'date-fns/difference_in_minutes'

import { Tooltip, Popover } from 'antd'
import humanizeDuration from 'humanize-duration'
import { getCustomerField } from '../../../customers/utils/getCustomerInfo'

import BlockedTime from './BlockedTimeEvent'
import { SnippetsFilled } from '@ant-design/icons'

export const sourceColor = {
	default: '#E9CF4B',
	onlineappointment: '#66ce89',
	onlinecheckin: 'rgba(101, 189, 248, 1.0)',
	walkin: '#CE66AB',
}

const sourceStyles = ({ sourceType }) =>
	sourceType !== 'default' &&
	css`
		.jewel {
			background-color: ${sourceColor[sourceType]};
		}
	`

const Container = styled('div')`
	z-index: 2;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	padding: 0 8px;
	overflow: hidden;
	line-height: 14px;
	background: rgba(101, 110, 222, 1);
	border-top: 1px solid rgba(249, 249, 249, 1) !important;
	border-radius: 4px;
	pointer-events: auto;
	cursor: pointer;

	.left {
		display: flex;
		align-items: center;
	}

	.time {
		font-size: 12px;
		white-space: nowrap;
		text-align: right;
	}

	.duration {
		font-size: 12px;
		opacity: 0.5;
	}

	.name {
		font-weight: 700;
		font-size: 14px;
		white-space: nowrap;
	}

	.service {
		font-size: 12px;
		white-space: nowrap;
		opacity: 0.5;
	}

	.jewel {
		margin-right: 6px;
		left: 4px;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	${sourceStyles};
`

const readable = {
	onlineappointment: 'via Online Appointment',
	onlinecheckin: 'via Online Check-in',
	walkin: 'via Walk-in',
	default: 'manually',
}

const CustomEvent = ({ event }) => {
	if (event.employeeId && !event.status) return <BlockedTime event={event} />

	const name = event.customer
		? `${getCustomerField(event.customer, 'firstName') || ''} ${
				getCustomerField(event.customer, 'lastName') || ''
		  }`
		: 'No Client'

	const sourceType = event?.source?.type || 'default'

	// event.start exists when resizing/dragging the event
	const duration = event.start ? differenceInMinutes(event.end, event.start) : event.duration

	return (
		<Container sourceType={sourceType}>
			<div className="left">
				{event.customerNote && (
					<Popover
						content={
							<div>
								<div style={{ fontSize: 16, fontWeight: 700, marginBottom: '0.2em' }}>
									Customer Comment/Request
								</div>
								<div>{event.customerNote}</div>
							</div>
						}
					>
						<SnippetsFilled style={{ marginRight: '0.5em', color: 'white', fontSize: 18 }} />
					</Popover>
				)}

				<div className="left">
					<Tooltip placement="right" title={`booked ${readable[sourceType]}`}>
						<div className="jewel" />
					</Tooltip>

					<div className="details">
						<div className="name">{name}</div>
						{duration > 10 && event.services?.[0] && (
							<div className="service">
								{event.services.length > 1 ? 'Multiple Services' : event.services?.[0]?.name}
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="time">
				{format(event.start || event.startTime, 'h:mm A')} -{' '}
				{format(event.end || event.endTime, 'h:mm A')}
				{duration > 10 && <div className="duration">{humanizeDuration(duration * 60000)}</div>}
			</div>
		</Container>
	)
}

export default CustomEvent
